import { cps, timeline } from "@/mocks/manga";

const toneClass: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

const toneSoft: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function Romance() {
  return (
    <section id="romance" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-5 lg:gap-12">
          {/* CP 卡片 */}
          <div className="lg:col-span-2">
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
              <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
              CP感情线
            </p>
            <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              那些值得磕的 <span className="text-primary-600">CP 组合</span>
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              主线、守护线、友情向，从双向奔赴到默默成全，每一段关系都值得细细品味。
            </p>

            <div className="mt-8 space-y-4">
              {cps.map((cp) => (
                <div
                  key={cp.id}
                  className="rounded-2xl border border-background-200/80 bg-background-50 p-5"
                >
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                      <span aria-hidden="true">{cp.emoji}</span>
                      {cp.name}
                    </h3>
                    <span className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${toneSoft[cp.tone]}`}>
                      {cp.status}
                    </span>
                  </div>
                  <p className="mt-2 text-xs font-medium text-primary-600">{cp.type} · {cp.member}</p>
                  <p className="mt-2 text-sm leading-7 text-foreground-700">{cp.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 时间轴 */}
          <div className="lg:col-span-3">
            <h3 className="font-heading text-xl font-bold text-foreground-950">
              主线感情线时间轴
            </h3>
            <p className="mt-2 text-sm text-foreground-700">
              从初遇到定情，五个阶段完整梳理恋爱辅助器漫画的<strong className="font-semibold text-primary-700">感情线发展</strong>。
            </p>

            <div className="relative mt-8 space-y-8 before:absolute before:left-[15px] before:top-2 before:h-[calc(100%-16px)] before:w-px before:bg-background-300 md:before:left-[23px]">
              {timeline.map((step) => (
                <article key={step.id} className="relative pl-12 md:pl-16">
                  <span
                    className={`absolute left-[6px] top-1 flex h-5 w-5 items-center justify-center rounded-full md:left-[14px] md:h-6 md:w-6 ${toneClass[step.id === "s5" ? "accent" : "primary"]}`}
                  >
                    <i className="ri-check-line text-[10px] text-white" aria-hidden="true"></i>
                  </span>

                  <div className="grid gap-4 sm:grid-cols-[200px_1fr]">
                    <div className="overflow-hidden rounded-xl">
                      <img
                        src={step.image}
                        alt={`恋爱辅助器漫画感情线${step.title}`}
                        className="aspect-[16/10] w-full object-cover object-top"
                      />
                    </div>
                    <div>
                      <p className="text-xs font-medium text-accent-700">{step.range}</p>
                      <h4 className="mt-1 font-heading text-base font-bold text-foreground-950">
                        {step.title}
                      </h4>
                      <span className="mt-2 inline-block whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                        {step.tag}
                      </span>
                      <p className="mt-2 text-sm leading-7 text-foreground-700">{step.desc}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}